import { render, staticRenderFns } from "./StarShop.vue?vue&type=template&id=50efe2d6&scoped=true"
import script from "./StarShop.vue?vue&type=script&lang=js"
export * from "./StarShop.vue?vue&type=script&lang=js"
import style0 from "./StarShop.vue?vue&type=style&index=0&id=50efe2d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50efe2d6",
  null
  
)

export default component.exports